import React, { useEffect, useState } from 'react';
import Sidebar from '../../components/Admin/Sidebar';
import { getAllNews, createNews, deleteNews, updateNews } from '../../api';
import useGroupsStore from '../../stores/groupsStore';
import useAdminAuthStore from '../../stores/adminAuthStore';
import AdminBottomNavBar from '../../components/Admin/AdminBottomNavBar';
import { getStaticBaseUrl } from '../../stores/configStore';

function AdminNews() {
  const [news, setNews] = useState([]);
  const [loading, setLoading] = useState(true);
  const [modalOpen, setModalOpen] = useState(false);
  const [title, setTitle] = useState('');
  const [text, setText] = useState('');
  const [selectedGroups, setSelectedGroups] = useState([]);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');
  const [image, setImage] = useState(null);
  const [editModalOpen, setEditModalOpen] = useState(false);
  const [editId, setEditId] = useState(null);
  const [editTitle, setEditTitle] = useState('');
  const [editText, setEditText] = useState('');
  const [editGroups, setEditGroups] = useState([]);
  const { groups, fetchGroups } = useGroupsStore();
  const token = useAdminAuthStore(state => state.token);

  useEffect(() => {
    fetchNews();
    fetchGroups();
    // eslint-disable-next-line
  }, []);

  async function fetchNews() {
    setLoading(true);
    try {
      const data = await getAllNews();
      setNews(data);
    } catch {
      setNews([]);
    } finally {
      setLoading(false);
    }
  }

  async function handleAddNews(e) {
    e.preventDefault();
    setSaving(true);
    setError('');
    try {
      await createNews({ title, text, groupIds: selectedGroups, image, token });
      setTitle(''); setText(''); setSelectedGroups([]); setImage(null); setModalOpen(false);
      await fetchNews();
    } catch (e) {
      setError(e.message);
    } finally {
      setSaving(false);
    }
  }

  async function handleDelete(id) {
    if (!window.confirm('Удалить новость?')) return;
    await deleteNews(id, token);
    await fetchNews();
  }

  function openEditModal(n) {
    setEditId(n._id);
    setEditTitle(n.title);
    setEditText(n.text);
    setEditGroups(n.groupIds ? n.groupIds.map(g => g._id || g) : []);
    setEditModalOpen(true);
  }

  async function handleEditNews(e) {
    e.preventDefault();
    setSaving(true);
    setError('');
    try {
      await updateNews({ id: editId, title: editTitle, text: editText, groupIds: editGroups, token });
      setEditModalOpen(false);
      setEditId(null);
      setEditTitle('');
      setEditText('');
      setEditGroups([]);
      await fetchNews();
    } catch (e) {
      setError(e.message);
    } finally {
      setSaving(false);
    }
  }

  return (
    <div className='AdminNews'>
      <div className="AdminNews__container">
        <Sidebar className="admin-sidebar" />
        <div className="content_admin">
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 24 }}>
            <h2 style={{ fontWeight: 700, fontSize: 28 }}>Новости</h2>
            <button onClick={() => setModalOpen(true)} style={{ background: '#6c3be4', color: '#fff', border: 'none', borderRadius: 8, padding: '10px 28px', fontWeight: 600, fontSize: 17, cursor: 'pointer' }}>Добавить новость</button>
          </div>
          {loading ? (
            <div style={{ color: '#888', margin: 40 }}>Загрузка...</div>
          ) : news.length === 0 ? (
            <div style={{ color: '#888', margin: 40 }}>Нет новостей</div>
          ) : (
            <ul style={{ listStyle: 'none', padding: 0, margin: 0, maxWidth: 900 }}>
              {news.map(n => (
                <li key={n._id} style={{ background: '#f7f7f9', borderRadius: 16, marginBottom: 32, boxShadow: '0 2px 12px #ece9f7', padding: 28, position: 'relative', display: 'flex', alignItems: 'flex-start', gap: 28 }}>
                  {/* Картинка */}
                  <div style={{ width: 110, minWidth: 110, height: 110, background: '#ece9f7', borderRadius: 12, overflow: 'hidden', display: 'flex', alignItems: 'center', justifyContent: 'center', boxShadow: '0 1px 6px #e0e0e0' }}>
                    {n.image ? (
                      <img src={`${getStaticBaseUrl()}${n.image}`} alt="news" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                    ) : (
                      <div style={{ color: '#bbb', fontSize: 38 }}>📰</div>
                    )}
                  </div>
                  {/* Контент */}
                  <div style={{ flex: 1, minWidth: 0, display: 'flex', flexDirection: 'column', gap: 8 }}>
                    <div style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', gap: 16 }}>
                      <div style={{ fontWeight: 700, fontSize: 24, marginBottom: 2, lineHeight: 1.2, wordBreak: 'break-word' }}>{n.title}</div>
                      <div style={{ display: 'flex', gap: 10 }}>
                        <button onClick={() => openEditModal(n)} style={{ background: '#f7c948', color: '#222', border: 'none', borderRadius: 7, padding: '7px 20px', fontWeight: 500, fontSize: 16, cursor: 'pointer', boxShadow: '0 1px 4px #f7e7b7' }}>Редактировать</button>
                        <button onClick={() => handleDelete(n._id)} style={{ background: '#e74c3c', color: '#fff', border: 'none', borderRadius: 7, padding: '7px 20px', fontWeight: 500, fontSize: 16, cursor: 'pointer', boxShadow: '0 1px 4px #f7b7b7' }}>Удалить</button>
                      </div>
                    </div>
                    <div style={{ color: '#444', fontSize: 17, marginBottom: 8, whiteSpace: 'pre-line', overflow: 'hidden', display: '-webkit-box', WebkitLineClamp: 3, WebkitBoxOrient: 'vertical', lineHeight: 1.5 }}>{n.text}</div>
                    <div style={{ color: '#888', fontSize: 14, marginBottom: 2 }}>Дата: {n.date ? new Date(n.date).toLocaleString() : ''}</div>
                    <div style={{ color: '#888', fontSize: 14, marginBottom: 2 }}>Автор: {n.author?.fullName || '—'}</div>
                    <div style={{ color: '#888', fontSize: 14 }}>Группы: {n.groupIds && n.groupIds.length > 0 ? n.groupIds.map(g => g.name).join(', ') : 'Для всех'}</div>
                  </div>
                </li>
              ))}
            </ul>
          )}
          {modalOpen && (
            <div className="admin-users-modal-overlay">
              <div className="admin-users-modal-content" style={{ minWidth: 400 }}>
                <h3 style={{ marginBottom: 20 }}>Добавить новость</h3>
                <form onSubmit={handleAddNews}>
                  <div style={{ marginBottom: 16 }}>
                    <label>Заголовок:</label>
                    <input value={title} onChange={e => setTitle(e.target.value)} required style={{ width: '100%', marginTop: 4 }} />
                  </div>
                  <div style={{ marginBottom: 16 }}>
                    <label>Текст:</label>
                    <textarea value={text} onChange={e => setText(e.target.value)} required style={{ width: '100%', marginTop: 4, minHeight: 80 }} />
                  </div>
                  <div style={{ marginBottom: 16 }}>
                    <label>Группы (если не выбрано — новость для всех):</label>
                    <select multiple value={selectedGroups} onChange={e => setSelectedGroups(Array.from(e.target.selectedOptions, o => o.value))} style={{ width: '100%', marginTop: 4, minHeight: 60 }}>
                      {groups.map(g => <option value={g._id} key={g._id}>{g.name}</option>)}
                    </select>
                  </div>
                  <div style={{ marginBottom: 16 }}>
                    <label>Изображение (опционально):</label>
                    <input type="file" accept="image/*" onChange={e => setImage(e.target.files[0])} style={{ marginTop: 4 }} />
                  </div>
                  {error && <div style={{ color: 'red', marginBottom: 8 }}>{error}</div>}
                  <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 12 }}>
                    <button type="button" className="admin-users-modal-btn" onClick={() => setModalOpen(false)}>Отмена</button>
                    <button type="submit" className="admin-users-modal-btn admin-users-modal-btn-primary" disabled={saving}>{saving ? 'Добавление...' : 'Добавить'}</button>
                  </div>
                </form>
              </div>
            </div>
          )}
          {editModalOpen && (
            <div className="admin-users-modal-overlay">
              <div className="admin-users-modal-content" style={{ minWidth: 400 }}>
                <h3 style={{ marginBottom: 20 }}>Редактировать новость</h3>
                <form onSubmit={handleEditNews}>
                  <div style={{ marginBottom: 16 }}>
                    <label>Заголовок:</label>
                    <input value={editTitle} onChange={e => setEditTitle(e.target.value)} required style={{ width: '100%', marginTop: 4 }} />
                  </div>
                  <div style={{ marginBottom: 16 }}>
                    <label>Текст:</label>
                    <textarea value={editText} onChange={e => setEditText(e.target.value)} required style={{ width: '100%', marginTop: 4, minHeight: 80 }} />
                  </div>
                  <div style={{ marginBottom: 16 }}>
                    <label>Группы (если не выбрано — новость для всех):</label>
                    <select multiple value={editGroups} onChange={e => setEditGroups(Array.from(e.target.selectedOptions, o => o.value))} style={{ width: '100%', marginTop: 4, minHeight: 60 }}>
                      {groups.map(g => <option value={g._id} key={g._id}>{g.name}</option>)}
                    </select>
                  </div>
                  {error && <div style={{ color: 'red', marginBottom: 8 }}>{error}</div>}
                  <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 12 }}>
                    <button type="button" className="admin-users-modal-btn" onClick={() => setEditModalOpen(false)}>Отмена</button>
                    <button type="submit" className="admin-users-modal-btn admin-users-modal-btn-primary" disabled={saving}>{saving ? 'Сохранение...' : 'Сохранить'}</button>
                  </div>
                </form>
              </div>
            </div>
          )}
        </div>
      </div>
      <AdminBottomNavBar />
    </div>
  );
}

export default AdminNews; 